import { memo } from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import SidePane from '../../../../core/components/SidePane';
import useTabletView from '../../../../core/hooks/dom/useTabletView';
import Divider from '../../../../core/components/Divider';
import Button from '../../../../core/components/Button';
import HorizontalLayout from '../../../../core/components/layout/HorizontalLayout';
import CompanyLogo from '../../../../core/components/CompanyLogo';
import FadeScroll from '../../../../core/components/layout/FadeScroll/FadeScroll';
import ProductAppliedFiltersList from './ProductAppliedFiltersList';
import styles from './FilterSideBar.module.scss';

const FilterSideBar = ({
    show,
    onClose,
    children,
    header,
    ignoreList,
    alwaysSidePane,
}: {
    show: boolean;
    onClose: () => void;
    children: ReactNode;
    header: ReactNode;
    ignoreList?: string[];
    alwaysSidePane?: boolean;
}) => {
    const isTabletView = useTabletView();

    if (isTabletView || alwaysSidePane) {
        return (
            <>
                {show && (
                    <SidePane
                        onClose={onClose}
                        header={
                            <div className={styles.logo}>
                                <CompanyLogo />
                            </div>
                        }
                    >
                        <div
                            className={styles.container}
                            data-test-class="filterSideBar"
                        >
                            <div className={styles.divider}>
                                <Divider light lengthPercentage={100} />
                            </div>
                            <FadeScroll
                                className={styles.scrollBody}
                                mode="vertical"
                            >
                                <div className={styles.header}>{header}</div>
                                <div className={styles.appliedList}>
                                    <ProductAppliedFiltersList
                                        mobile
                                        ignoreList={ignoreList}
                                    />
                                </div>

                                <div className={styles.content}>{children}</div>
                            </FadeScroll>
                            <div className={styles.closeButton}>
                                <HorizontalLayout justify="center">
                                    <Button primary onPress={onClose}>
                                        <FormattedMessage id="show products" />
                                    </Button>
                                </HorizontalLayout>
                            </div>
                        </div>
                    </SidePane>
                )}
            </>
        );
    }
    return <div className={styles.sidebar}>{children}</div>;
};

export default memo(FilterSideBar);
